import React from "react";
import AbcdData from "../../utils/AbcdData";
import { imageUrl } from "../../utils/imageUrl";
import { ColorArray } from "../../config/ColorArray";   // ✅ ADD THIS
import "./AbcdData.css";
import SectionDivider from "../../common/SectionDivider";

const EnglishAbcd = () => {
    return (
        <>
        <SectionDivider title="અંગ્રેજી એબીસીડી" />
        <div className="abcd-container">
            
            <div className="abcd-grid">
                {AbcdData.map((item, index) => {
                    const textColor = ColorArray[index % ColorArray.length]?.color2;

                    return (
                        <div className="abcd-card" key={index}>

                            {/* LEFT */}
                            <div className="abcd-left">
                                <span
                                    className="abcd-letter"
                                    style={{ color: textColor }}
                                >
                                    {item.axar}
                                </span>

                                <span
                                    className="abcd-word"
                                    style={{ color: textColor }}
                                >
                                    {item.title}
                                </span>
                            </div>

                            {/* RIGHT */}
                            <div className="abcd-right">
                                {item.image ? (
                                    <img
                                        src={imageUrl(item.image)}
                                        className="abcd-img"
                                        alt=""
                                        onError={(e) => (e.target.style.display = "none")}
                                    />
                                ) : (
                                    <span className="abcd-emoji">{item.img}</span>
                                )}
                            </div>

                        </div>
                    );
                })}
            </div>
        </div>
        </>
    );
};

export default EnglishAbcd;
